import { event } from '..';
import { assertDuplicateWithinWindow } from '../assert-duplicate-within-window';
import { logEventWarning } from '../log';

export const pageView = () => {
  // Ignore any duplicate events within a 1 second window
  const isDuplicateEvent = assertDuplicateWithinWindow(1000);

  return (url: string) => {
    if (isDuplicateEvent(url)) {
      logEventWarning('page_view');

      return;
    }

    event({ type: 'page_view' });
  };
};
